module.exports = __webpack_public_path__ + "media/assets/images/flags/bs-81ee3fce87204a8577f14492b4a846ee.svg";